import {useEffect, useRef} from 'react';
import {useLocation, useNavigationType} from 'react-router-dom';

const scrollPositions = new Map<string, number>();

export function ScrollRestoration() {
  const {pathname} = useLocation();
  const navigationType = useNavigationType();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      // Save scroll position for the page we're leaving
      scrollPositions.set(prevPathname.current, window.scrollY);
      prevPathname.current = pathname;
    }

    if (navigationType === 'POP') {
      // Back/forward — restore saved position
      const saved = scrollPositions.get(pathname);
      if (saved !== undefined) {
        // Defer to let the DOM render first
        requestAnimationFrame(() => window.scrollTo(0, saved));
      }
    } else {
      // PUSH or REPLACE — scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return null;
}
